'use client';
import React from "react";
import AppshellWrapper from "@components/AppshellWrapper/AppshellWrapper";
import { getHealthInsuranceProps } from "@lib/strapiFunctions/healthInsurancePage";
import "styles/NotFound/Error.css";
import NotFoundTab from "app/components/404/NotFoundTab";

const ErrorComponent = ({ homePageData, popularSearches, dynamicFooterData }) => {
  return (
    <>
      <AppshellWrapper
        homePageData={homePageData} 
        popularSearches={true}
        dynamicFooterData={dynamicFooterData}
      > 
      <div className="bg-white flex flex-col relative gap-8 items-center pb-10 text-center md:text-left px-4 md:px-0 mx-auto max-w-[1280px] w-full">
        <img src="/aem-to-react/not-found/404-not-found.png" alt="400 Image" loading="lazy" className="md:h-auto md:w-[40%] w-full" />
      </div>
      <div className="bg-white flex flex-col relative gap-3 items-center pb-20 text-center md:text-left desk:px-16 md:px-8 px-4 mx-auto max-w-[1280px] w-full">
        <h1 className="md:text-4xl text-xl font-bold mb-2">Bad Request</h1>
        <p className="md:text-xl text-base mb-2">
            The server couldn’t understand your request. Please check your input.
        </p>
        <a href="https://www.nivabupa.com/" className="text-nivabupa-ethinosHomeOrange border px-3 py-2 md:mt-2 mt-5 border-nivabupa-ethinosHomeOrange rounded-md">Go to Homepage</a>
      </div>    
      <div className="bg-white desk:px-16 md:px-8 px-4 relative gap-8 items-center pb-20  mx-auto max-w-[1280px] w-full">
        <NotFoundTab />
      </div>  
    
      </AppshellWrapper>
    </>
  );
};

export async function getStaticProps() {
    return await getHealthInsuranceProps();
}

export default ErrorComponent;
